import { render, staticRenderFns } from "./BnDokLink.vue?vue&type=template&id=14eee374&scoped=true&"
import script from "./BnDokLink.vue?vue&type=script&lang=js&"
export * from "./BnDokLink.vue?vue&type=script&lang=js&"
import style0 from "./BnDokLink.vue?vue&type=style&index=0&id=14eee374&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14eee374",
  null
  
)

export default component.exports